const load = () => {
  return {
    page_title: "Client Info"
  };
};
export {
  load
};
//# sourceMappingURL=_page.ts.js.map
